const ZDANIA109 = [
  {
    name: "Słówka (PL/DE)",
    lang: 'de',
    zdania: [
      { pl: "ludzie ze stowarzyszenia / członkowie stowarzyszenia", de: "Vereinsleute" },
      { pl: "podpisać petycję", de: "die Petition unterschreiben" },
      { pl: "dom seniora / dom opieki", de: "Altersheim" },
      { pl: "seniorzy", de: "Senioren" },
      { pl: "zwierzęta", de: "Tiere" },
      { pl: "schronisko (dla zwierząt)", de: "Tierheim" },
      { pl: "interesować się czymś", de: "sich für etw. interessieren" },
      { pl: "angażować się na rzecz czegoś", de: "sich für etw. engagieren" },
      { pl: "troszczyć się o kogoś/coś", de: "sich um jdn./etw. kümmern" },
      { pl: "o / ponad", de: "über" },
      { pl: "na", de: "auf" },
      { pl: "cieszyć się", de: "sich freuen" },
      { pl: "cieszę się", de: "ich freue mich" },
      { pl: "cieszysz się", de: "du freust dich" },
      { pl: "cieszy się", de: "er / sie / es freut sich" },
      { pl: "cieszymy się", de: "wir freuen uns" },
      { pl: "cieszycie się", de: "ihr freut euch" },
      { pl: "cieszą się", de: "sie freuen sich" },
      { pl: "cieszą się Państwo", de: "Sie freuen sich" },
      { pl: "Na co się cieszysz? (na co czekasz z radością?)", de: "Worauf freust du dich?" },
      { pl: "Oni interesują się tą podróżą / wycieczką.", de: "Sie interessieren sich für die Reise / den Ausflug." },
      { pl: "Czy cieszycie się na Boże Narodzenie?", de: "Freut ihr euch auf Weihnachten?" },
      { pl: "O kogo się troszczycie?", de: "Um wen kümmert ihr euch?" },
      { pl: "W czym oni biorą udział?", de: "Woran nehmen sie teil?" },
      { pl: "Dyskutujemy o tym filmie.", de: "Wir diskutieren über diesen Film." },
      { pl: "Interesujemy się tą książką.", de: "Wir interessieren uns für dieses Buch." },
      { pl: "W co / na rzecz czego się angażujesz?", de: "Wofür engagierst du dich?" },
      { pl: "O kim pani rozmawia?", de: "Über wen sprechen Sie?" },
      { pl: "cieszyć się na coś", de: "sich auf etw. freuen" },
      { pl: "cieszyć się z czegoś", de: "sich über etw. freuen" },
      { pl: "Czym się interesujesz? — Ochroną środowiska." },
      { de: "Wofür interessierst du dich? — Für den Umweltschutz." },
      {
        pl: "Z czego się cieszą? — Z naszej pomocy.",
        de: "Worüber freuen sie sich? — Über unsere Hilfe.",
      },
      {
        pl: "O kogo się troszczycie? — O niepełnosprawne dzieci.",
        de: "Um wen kümmert ihr euch? — Um behinderte Kinder.",
      },
      {
        pl: "W czym biorą udział? — W Solidar-AG.",
        de: "Woran nehmen sie teil? — An der Solidar-AG.",
      },
      {
        pl: "Kim ona się interesuje? — Biednymi ludźmi w Afryce.",
        de: "Für wen interessiert sie sich? — Für arme Menschen in Afrika.",
      },
      {
        pl: "O kim dyskutują? — O starszych ludziach.",
        de: "Über wen diskutieren sie? — Über ältere Menschen.",
      },
      {
        pl: "Na co się cieszycie? — Na wizytę w domu seniora (domu opieki).",
        de: "Worauf freut ihr euch? — Auf den Besuch im Altersheim.",
      },
      {
        pl: "O co on dba/troszczy się? — O karmę dla zwierząt w schronisku.",
        de: "Worum kümmert er sich? — Um das Futter für Tiere im Tierheim.",
      },
    ],
  },
];

const ZDANIA111 = [
  {
    name: "Angielski Sty 2026",
    lang: 'en',
    zdania: [
      { pl: "plastyka", de: "art" },
      { pl: "języki obce", de: "foreign languages" },
      { pl: "geografia", de: "geography" },
      { pl: "historia", de: "history" },
      { pl: "informatyka", de: "IT / information technology" },
      { pl: "literatura", de: "literature" },
      { pl: "matematyka", de: "mathematics / maths" },
      { pl: "muzyka", de: "music" },
      { pl: "wychowanie fizyczne (WF)", de: "PE / physical education" },
      { pl: "religia", de: "RE / religious education" },
      { pl: "nauki przyrodnicze (biologia, chemia, fizyka) / przyroda", de: "science (biology, chemistry, physics)" },
      { pl: "przedmiot szkolny", de: "school subject" },

      { pl: "przedszkole", de: "nursery school / kindergarten / pre-school" },
      { pl: "szkoła podstawowa", de: "primary school" },
      { pl: "szkoła prywatna", de: "private school" },
      { pl: "elitarna szkoła prywatna (BrE)", de: "public school" },
      { pl: "szkoła publiczna/państwowa (AmE)", de: "public school" },
      { pl: "szkoła średnia", de: "secondary school" },
      { pl: "szkoła państwowa", de: "state school" },
      { pl: "uniwersytet", de: "university" },

      { pl: "stołówka", de: "canteen" },
      { pl: "sala lekcyjna", de: "classroom" },
      { pl: "szatnia", de: "cloakroom" },
      { pl: "świetlica / pokój wspólny", de: "common room" },
      { pl: "pracownia komputerowa", de: "computer room" },
      { pl: "korytarz", de: "corridor" },
      { pl: "sala gimnastyczna", de: "gym / gymnasium" },
      { pl: "aula / sala zgromadzeń", de: "hall" },
      { pl: "biblioteka", de: "library" },
      { pl: "szafka (ucznia)", de: "locker" },
      { pl: "sekretariat", de: "office" },
      { pl: "plac zabaw / szkolne podwórko", de: "playground" },
      { pl: "pracownia / laboratorium (biologiczne/chemiczne/fizyczne)", de: "science lab" },
      { pl: "boisko sportowe", de: "sports field" },
      { pl: "pokój nauczycielski", de: "staff room" },

      { pl: "tablica (czarna) / tablica ogólnie", de: "blackboard / board" },
      { pl: "dziennik lekcyjny / lista obecności", de: "class register" },
      { pl: "kredki ołówkowe", de: "coloured pencils" },
      { pl: "ławka / stolik ucznia", de: "desk" },
      { pl: "słownik", de: "dictionary" },
      { pl: "klej", de: "glue" },
      { pl: "zeszyt", de: "notebook / exercise book" },
      { pl: "strój gimnastyczny", de: "PE kit" },
      { pl: "piórnik", de: "pencil case" },
      { pl: "gumka", de: "rubber" },
      { pl: "linijka", de: "ruler" },
      { pl: "nożyczki", de: "scissors" },
      { pl: "tornister / plecak szkolny", de: "school bag" },
      { pl: "sprzęt sportowy", de: "sports equipment" },
      { pl: "podręcznik", de: "textbook / coursebook" },
      { pl: "tablica biała (suchościeralna)", de: "whiteboard" },

      { pl: "woźny / konserwator", de: "caretaker" },
      { pl: "kolega/koleżanka ze szkoły", de: "classmate / schoolmate" },
      { pl: "wychowawca / wychowawczyni", de: "form teacher / tutor" },
      { pl: "dyrektor / dyrektorka", de: "head teacher / headmaster / headmistress" },
      { pl: "bibliotekarz / bibliotekarka", de: "librarian" },
      { pl: "profesor / wykładowca akademicki", de: "professor" },
      { pl: "uczeń / uczennica", de: "pupil / schoolboy / schoolgirl" },
      { pl: "student (uczelni)", de: "student" },
      { pl: "grono pedagogiczne / kadra nauczycielska", de: "(teaching) staff" },

      { pl: "średni / przeciętny", de: "average" },
      { pl: "ściągać na egzaminie", de: "cheat in an exam / cheat on an exam" },
      { pl: "klasówka / sprawdzian", de: "class test" },
      { pl: "nie zdać egzaminu", de: "fail an exam" },
      { pl: "egzamin końcowy", de: "final exam / examination" },
      { pl: "dostać A", de: "get an A" },
      { pl: "dostać wyniki (czegoś)", de: "get the results of (sth)" },
      { pl: "stopień / ocena szkolna", de: "mark / grade" },
      { pl: "egzamin ustny", de: "oral exam" },
      { pl: "zdać egzamin", de: "pass an exam" },
      { pl: "przygotowywać się do egzaminów", de: "prepare for exams" },
      { pl: "poprawiać egzamin", de: "retake an exam" },
      { pl: "powtarzać / uczyć się do egzaminów", de: "revise for exams" },
      { pl: "egzamin kończący szkołę (np. matura)", de: "school-leaving exam" },
      { pl: "świadectwo / raport z ocen", de: "school report" },
      { pl: "kartkówka", de: "short test" },
      { pl: "uczyć się / przygotowywać się do", de: "study / prepare for" },
      { pl: "wkuwać", de: "swot" },
      { pl: "przystępować do egzaminu", de: "take an exam" },
      { pl: "egzamin pisemny", de: "written exam" },

      { pl: "zajęcia pozalekcyjne / kółko zainteresowań", de: "after-school activities / club" },
      { pl: "uczęszczać (na)", de: "attend" },
      { pl: "zacząć chodzić do szkoły", de: "begin school" },
      { pl: "przerwa", de: "break" },
      { pl: "konkurs / olimpiada", de: "competition" },
      { pl: "obowiązkowy", de: "compulsory" },
      { pl: "skupić się", de: "concentrate" },
      { pl: "przeszkadzać", de: "disturb" },
      { pl: "zajęcia dodatkowe", de: "extra activities" },
      { pl: "uroczystość zakończenia szkoły / rozdania świadectw", de: "graduation ceremony" },
      { pl: "nieobowiązkowy / dobrowolny", de: "optional" },
      { pl: "wywiadówka", de: "parent-teacher meeting" },
      { pl: "wycieczka szkolna", de: "school trip" },
      { pl: "mundurek szkolny", de: "school uniform" },
      { pl: "wakacje / ferie", de: "summer / winter holidays" },
      { pl: "plan lekcji", de: "timetable" },
      { pl: "lektury szkolne / lektury obowiązkowe", de: "set texts / set books" },
      { pl: "semestr / (czasem) trymestr", de: "term" },

      { pl: "(mało) ambitny", de: "(un)ambitious" },
      { pl: "kreatywny", de: "creative" },
      { pl: "wymagający", de: "demanding" },
      { pl: "wyluzowany / spokojny", de: "easy-going" },
      { pl: "doskonały / znakomity", de: "excellent" },
      { pl: "(nie)sprawiedliwy", de: "(un)fair" },
      { pl: "uzdolniony", de: "gifted" },
      { pl: "pracowity", de: "hard-working" },
      { pl: "(nie)pomocny", de: "(un)helpful" },
      { pl: "(nie)uczciwy", de: "(dis)honest" },
      { pl: "leniwy", de: "lazy" },
      { pl: "(nie)cierpliwy", de: "(im)patient" },
      { pl: "(nie)punktualny", de: "(un)punctual" },
      { pl: "szanowany", de: "respected" },
      { pl: "pełen szacunku / lekceważący", de: "(dis)respectful" },
      { pl: "surowy", de: "strict" },
      { pl: "utalentowany", de: "talented" },
      { pl: "(nie)tolerancyjny", de: "(in)tolerant" },
      { pl: "wyrozumiały", de: "understanding" },

      { pl: "być nieobecnym w szkole", de: "be absent from school" },
      { pl: "być dobry/zły w czymś", de: "be good/bad at sth" },
      { pl: "mieć prawdziwe kłopoty / być w tarapatach", de: "be in (real) trouble" },
      { pl: "spóźnić się do szkoły", de: "be late for school" },
      { pl: "być dobrze przygotowanym", de: "be well prepared" },
      { pl: "odpisać zadanie domowe", de: "copy homework" },
      { pl: "robić ćwiczenie / zadanie", de: "do an exercise / a task" },
      { pl: "dobrze/źle poradzić sobie na teście", de: "do well/badly in a test" },
      { pl: "dać z siebie wszystko", de: "do your best" },
      { pl: "odrabiać pracę domową", de: "do your homework" },
      { pl: "mieć zaległości", de: "fall behind" },
      { pl: "dostać się do szkoły średniej", de: "get into secondary school" },
      { pl: "przygotować się", de: "get ready" },
      { pl: "zrobić sobie przerwę", de: "have/take a break" },
      { pl: "uczyć się na pamięć", de: "learn by heart" },
      { pl: "rzucić szkołę / zakończyć naukę", de: "leave school" },
      { pl: "sprawdzić w słowniku / wyszukać", de: "look sth up" },
      { pl: "popełnić błąd", de: "make a mistake" },
      { pl: "robić postępy", de: "make progress" },
      { pl: "robić notatki", de: "make/take notes" },
      { pl: "opuszczać lekcje", de: "miss lessons" },
      { pl: "brać w czymś udział", de: "participate (in sth)" },
      { pl: "uważać / zwracać uwagę na kogoś/coś", de: "pay attention to sb/sth" },
      { pl: "wagarować", de: "play truant" },
      { pl: "uczyć się pilnie", de: "study hard" },
      { pl: "sprawdzać listę obecności", de: "take the register" },
      { pl: "pisać wypracowanie", de: "write an essay" },

      { pl: "zdolność", de: "ability" },
      { pl: "kontroler ruchu lotniczego", de: "air traffic controller" },
      { pl: "lotnictwo", de: "aviation" },
      { pl: "powodować", de: "cause" },
      { pl: "zawierać", de: "contain" },
      { pl: "krzyżówka", de: "crossword" },
      { pl: "zależeć od", de: "depend on" },
      { pl: "rozszerzyć / powiększyć / rozwinąć", de: "expand" },
      { pl: "najnowsze badania", de: "latest research" },
      { pl: "nieporozumienie", de: "misunderstanding" },
      { pl: "skutkować czymś / skończyć się czymś", de: "result in sth" },
      { pl: "zestaw", de: "set" },
      { pl: "przyklejać (się) / kleić (się)", de: "stick" },
      { pl: "aktualny / nowoczesny", de: "up to date" }
    ]
  }
];


export { ZDANIA109, ZDANIA111 };